// ----------------- START SIGN IN SCRIPT ------------------------------------

window.addEventListener("breeze-signed-in", (event) => {
  const eventData = event.detail;
  breezeSignIn(eventData);
});

// This function will be invoked by breeze after sign in
function breezeSignIn(payload) {
  try {
    merchantSignInCustomCode(payload.data);
  } catch (e) {
    console.error("Error in triggering merchants purchase script : ", e);
  }
}

// merchant script for `sign_in` will be pasted here
function merchantSignInCustomCode(params) {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "GTM-584LZF");
  // window.gtag("event", "signed_in", {
  //   mobile: params.phoneNumber
  // });
  window.dataLayer.push({
    event: "sign_in",
    mobile: params.phoneNumber
  });
}

// ----------------- END SIGN IN SCRIPT --------------------------------------

// ----------------- START PAY NOW SCRIPT ------------------------------------

window.addEventListener("breeze-pay-now", (event) => {
  const eventData = event.detail;
  breezePayNow(eventData);
});

// This function will be invoked by breeze after user proceeds to pay
function breezePayNow(payload) {
  try {
    merchantPayNowCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}

// merchant script for `pay_now` will be pasted here
function merchantPayNowCustomCode(params) {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "GTM-584LZF");
  // window.gtag("event", "signed_in", {
  //   mobile: params.phoneNumber
  // });
  window.dataLayer.push({
    event: "pay_now",
  });
  
}

// ----------------- END PAY NOW SCRIPT --------------------------------------